export var RadioButtonsDirections = {
    vertical: 'vertical',
    horizontal: 'horizontal',
};
export var RadioButtonsTypes = {
    solid: 'solid',
    outlined: 'outlined',
    grouped: 'grouped',
};
